import type { ForNodeType } from "@/components/features/_model/types";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion/accordion";
import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";
import { Image } from "@/components/ui/image/image";

const DISPLAY_GUIDE_ACCORDION_VALUE = "date-tabbed-time-selection-display-guide";

type Props = {
	isDateTabbedTimeSelectionEnabled: ForNodeType<boolean>;
	onSetIsDateTabbedTimeSelectionEnabled: (input: boolean) => void;
	isEnabled: boolean;
};

export const QuestionOptionDateTabbedTimeSelectionEnabled = ({
	isDateTabbedTimeSelectionEnabled,
	onSetIsDateTabbedTimeSelectionEnabled,
	isEnabled,
}: Props) => {
	return (
		<div className="grid gap-4">
			<div className={isEnabled ? "grid gap-2" : "pointer-events-none grid gap-2 opacity-50"}>
				<CheckboxField
					value={isDateTabbedTimeSelectionEnabled.value}
					label="予約画面の最初のステップでこのサブオプションを選択させる"
					handleChange={onSetIsDateTabbedTimeSelectionEnabled}
					errorMessage={isDateTabbedTimeSelectionEnabled.error}
				/>

				<div className="space-y-2 pl-7">
					<p className="text-sm text-caption-50">
						上記のチェックの有無により、予約画面でのサブオプションの表示タイミングと選び方が変わります。
					</p>

					<Accordion type={"single"} collapsible>
						<AccordionItem value={DISPLAY_GUIDE_ACCORDION_VALUE} borderBottom={false} className="border-0">
							<AccordionTrigger
								arrowLeft
								className="gap-x-2 py-1 text-sm font-normal text-zinc-600 hover:no-underline"
							>
								表示の違いを確認する
							</AccordionTrigger>

							<AccordionContent className="pl-0 pt-2">
								<div className="grid gap-6 rounded-md border bg-zinc-50 p-5 text-sm text-zinc-600">
									<div className="grid gap-3">
										<p className="font-semibold">無効にした場合</p>
										<p>
											サブオプションは通常のオプション選択ステップで表示されます。
										</p>
										<div className="overflow-hidden rounded-md border border-zinc-200">
											<Image
												src="/assets/sub-option/date-tabbed-time-selection-off.png"
												alt="チェックなしの場合の予約画面イメージ"
												className="w-full"
											/>
										</div>
									</div>
									<div className="grid gap-3">
										<p className="font-semibold">有効にした場合</p>
										<p>
											予約フローの最初のステップで、宿泊日ごとのタブが切り替わる形で時間帯選択欄が表示されます。
										</p>
										<div className="overflow-hidden rounded-md border border-zinc-200">
											<Image
												src="/assets/sub-option/date-tabbed-time-selection-on.png"
												alt="チェックありの場合の予約画面イメージ"
												className="w-full"
											/>
										</div>
									</div>
								</div>
							</AccordionContent>
						</AccordionItem>
					</Accordion>
				</div>
			</div>

			{!isEnabled && (
				<div className="text-sm text-caption-50">
					<p>サブオプションとして使用する設定をすると操作できます</p>
				</div>
			)}
		</div>
	);
};

QuestionOptionDateTabbedTimeSelectionEnabled.displayName = "QuestionOptionDateTabbedTimeSelectionEnabled";
